import { OpportunityKind } from 'anchor-scout-common/types';
import { routes } from '~/constants';
const DESTINATION_SCOPE_BY_KIND = {
    [OpportunityKind.StalePrice]: 'agreement',
    [OpportunityKind.DiscountLeak]: 'agreement',
    [OpportunityKind.CrossSell]: 'client',
    [OpportunityKind.RecurringAdhoc]: 'client'
};
export const opportunityDestination = (opportunity)=>DESTINATION_SCOPE_BY_KIND[opportunity.kind] === 'agreement' && opportunity.relationshipId != null ? {
        scope: 'agreement',
        relationshipId: opportunity.relationshipId
    } : {
        scope: 'client',
        clientId: opportunity.clientId
    };
export const opportunityRoute = (opportunity)=>{
    const destination = opportunityDestination(opportunity);
    return destination.scope === 'agreement' ? routes.editAgreement(destination.relationshipId) : routes.client(destination.clientId);
};
